import { v4 as uuidv4 } from 'uuid';

function generateRequestId() {
  return uuidv4();
}

export function getDefaultOptions() {
  return {
    contentType: 'application/json',
    dataType: 'json',
    cacheResponse: false,
    'x-ms-requestid': generateRequestId(),
    xhrFields: {
      withCredentials: true,
    },
  };
}
